// Calendar days in the organisation's own time zone (Settings → Organisation profile / Finance → Time zone).
// Every "today", every day a moment fell on (a PO issued at 23:30, a report submitted just after midnight) and every
// date the screens fill in for you is worked out here, in the organisation's zone — never the server's or the
// browser's clock zone, and never a fixed UK time. Date-only fields (ETD, ETA, expiry dates…) are plain days and are
// never moved between zones.

/** The calendar day (YYYY-MM-DD) that the moment `at` falls on in time zone `tz`. */
export function dayIn(at: Date | string | number, tz: string): string {
  const d = at instanceof Date ? at : new Date(at);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone: tz || "UTC", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
}

/** The hour (0–23) of the moment `at` in time zone `tz`. */
export function hourIn(at: Date, tz: string): number {
  try {
    return Number(new Intl.DateTimeFormat("en-GB", { timeZone: tz || "UTC", hour: "2-digit", hourCycle: "h23" }).format(at));
  } catch {
    return at.getUTCHours();
  }
}
